var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/send-pdf-history.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-32896964!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/send-pdf-history.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/SendPdfHistory.vue
// module id = 352
// module chunks = 1